import RestClient from "RestClient";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const restClient = new RestClient();

export const getClientList = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/clients`,payload);
    return result?.data; 
}


export const getNewClientList = async () => {
    const result = await restClient.get(`${BASE_URL}/clients/new`,[]);
    return result?.data; 
}


export const addClient = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/clients/create`, payload);
    return result; 
}

export const updateClient = async (id, payload) => {
    const result = await restClient.put(`${BASE_URL}/clients/${id}`, payload);
    return result?.data; 
}

export const getSingleClient = async (id) => {
    const result = await restClient.get(`${BASE_URL}/clients/${id}`);
    return result?.data; 
}

export const inviteClient = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/clients/inviteClient?firstName=${payload.firstName}&lastName=${payload.lastName}&email=${encodeURIComponent(payload.email)}&senderName=${payload.senderName}&agentId=${payload.agentId}&brokerId=${payload.brokerId}`);
    return result?.data; 
}
export const inviteAgent = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/clients/inviteAgent?firstName=${payload.firstName}&lastName=${payload.lastName}&email=${encodeURIComponent(payload.email)}&senderName=${payload.senderName}&id=${payload.id}`);
    return result?.data; 
}
export const inviteBroker = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/clients/inviteBroker?firstName=${payload.firstName}&lastName=${payload.lastName}&email=${encodeURIComponent(payload.email)}&senderName=${payload.senderName}&phoneNumber=${payload.phoneNumber}&companyName=${payload.companyName}&id=${payload.id}&clientid=${payload.clientid}`);
    return result?.data; 
}
export const requestAccess = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/clients/requestAccess?firstName=${payload.firstName}&lastName=${payload.lastName}&email=${payload.email}&senderName=${payload.senderName}&id=${payload.id}`);
    return result?.data; 
}
export const grantAccess = async (payload) => {
    const result = await restClient.put(`${BASE_URL}/users/agentAccessRequest`,payload);
    return result?.data; 
}